
export default class MemberCommunicationResponseModel {
    public communicationDateTimeUtc?: Date;
    public communicationType: string = '';
    public communicationToken: string = '';
}
